import { queryOptions } from "@tanstack/react-query";
import {
  getOrganizationAthleteProfile,
  updateOrganizationAthleteProfile,
} from "api-client";
import { assert } from "utils";

import {
  type AthleteProfile,
  type AthletesRepository,
} from "./AthletesRepository";

export function createOrganizationAthletesRepository(
  organizationId: string,
): AthletesRepository {
  return {
    profileOptions(athleteId) {
      return queryOptions<AthleteProfile>({
        queryKey: [
          "organizations",
          organizationId,
          "athletes",
          athleteId,
          "profile",
        ],
        async queryFn() {
          assert(athleteId, "Athlete ID is required");
          const response = await getOrganizationAthleteProfile({
            path: { organizationId, athleteId },
          });
          return response.data.data;
        },
      });
    },
    updateProfile(athleteId, input) {
      return updateOrganizationAthleteProfile({
        path: { organizationId, athleteId },
        body: input,
      });
    },
  };
}
